import { drawerAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { type StyleFunctionProps } from '@chakra-ui/theme-tools';
import { Modal as modalTheme } from './Modal';
import { Radii } from '../../types';
const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(parts.keys);

const modalProps: StyleFunctionProps = {
  colorScheme: '',
  colorMode: 'light',
  theme: {},
};
const baseStyle = definePartsStyle(() => {
  return {
    header: {
      ...modalTheme?.baseStyle?.(modalProps)?.header,
    },
    closeButton: {
      ...modalTheme?.baseStyle?.(modalProps)?.closeButton,
    },
    body: {
      ...modalTheme?.baseStyle?.(modalProps)?.body,
    },
    dialog: {
      borderRadius: Radii.NONE,
    },
    footer: {
      ...modalTheme?.baseStyle?.(modalProps)?.footer,
    },
  };
});

export const Drawer = defineMultiStyleConfig({ baseStyle });
